// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"MenuBar_menuBar__tybhC","divider":"MenuBar_divider__7qtkI"};